export const useAuthSocial = () => {
  const route = useRoute();
  const { getSecureQueryParam } = useRoutes();
  const { setAuthSocialData, clearAuthSocialData } = useAuthSocialStore();

  const { socialEmail, socialToken, socialService, isSocialAuthFlow } =
    storeToRefs(useAuthSocialStore());

  const setSocialData = () => {
    if (!route.query.email || !route.query.token || !route.query.service) {
      return;
    }

    const {
      isGoogleButtonActive,
      isFacebookButtonActive,
      isTwitchButtonActive,
      isSteamButtonActive,
    } = useFeatureFlagsNew();

    const socialAllowedServices = [];

    if (isGoogleButtonActive.value) {
      socialAllowedServices.push('google');
    }

    if (isFacebookButtonActive.value) {
      socialAllowedServices.push('facebook');
    }

    if (isTwitchButtonActive.value) {
      socialAllowedServices.push('twitch');
    }

    if (isSteamButtonActive.value) {
      socialAllowedServices.push('steam');
    }

    const email = getSecureQueryParam(route.query.email) as string;
    const token = getSecureQueryParam(route.query.token) as string;
    const service = getSecureQueryParam(route.query.service) as string;

    if (!socialAllowedServices.includes(service)) {
      return;
    }

    setAuthSocialData({
      email,
      token,
      service,
    });

    clearQueryParams();
  };

  const clearSocialData = () => {
    clearAuthSocialData();
  };

  return {
    socialEmail,
    socialToken,
    socialService,
    isSocialAuthFlow,
    setSocialData,
    clearSocialData,
  };
};
